import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TopHeading from "./TopHeading";
import Heading from "./Heading";
import { LOCAL_STORAGE_KEY, PATH } from "../../constants";
import { handleNavigation } from "../../services/services";
import PopupComponent from "../Common/Popup/PopupComponent";
import { localGetItem } from "../../utils/localStorage";
import merchantStore from "../../store/merchantStore";
import appStore from "../../store/appStore";
import { ERROR_CODE } from "../../constants/error";
import { refresh } from "../../network/api";
import DownloadApp from "../DownloadApp";
import { deleteCookie, getCookie } from "../../utils";
import MobileModal from "../Common/Popup/MobileModal";

const Header = () => {
    const location = useLocation();
    const pathname = location.pathname;
    const navigate = useNavigate();
    const { getMerchantProfile } = merchantStore() || {};
    const { setFromNativeApp } = appStore() || {};

    useEffect(() => {
        handleMerchant();
        const messageHandler = (message) => {
            if (message.data === 'Load from native app') {
                setFromNativeApp(true);
            }
        };
        window.addEventListener('message', messageHandler);
        return () => {
            window.removeEventListener('message', messageHandler);
        };
    }, []);

    useEffect(() => {
        // scroll to top when route changes smoothly
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [pathname]);

    const handleMerchant = async () => {
        const searchParams = new URLSearchParams(location.search);
        const fromBuyer = searchParams.get('from') === 'buyer';
        const sso = searchParams.get('sso'); // "1" | "0" | null

        const tokenShare = getCookie('token-share');
        const tokenLocal = localGetItem({key: LOCAL_STORAGE_KEY.TOKEN, type: 'string'});

        let token = tokenLocal || '';

        if (fromBuyer) {
            if (sso === '0') {
                window.localStorage.removeItem(LOCAL_STORAGE_KEY.TOKEN);
                window.localStorage.removeItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN);
                deleteCookie('token-share');
                navigate(PATH.LOGIN);
                return;
            }

            if (sso === '1') {
                if (tokenShare && tokenShare !== 'logout') {
                    token = tokenShare;
                    window.localStorage.setItem(LOCAL_STORAGE_KEY.TOKEN, tokenShare || '');
                } else {
                    window.localStorage.removeItem(LOCAL_STORAGE_KEY.TOKEN);
                    window.localStorage.removeItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN);
                    deleteCookie('token-share');
                    navigate(PATH.LOGIN);
                    return;
                }
            }
        } else if (tokenShare && tokenShare !== 'logout') {
            token = tokenShare;
            window.localStorage.setItem(LOCAL_STORAGE_KEY.TOKEN, tokenShare || '');
        }

        if (!token) {
            window.localStorage.removeItem(LOCAL_STORAGE_KEY.TOKEN);
            window.localStorage.removeItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN);
            deleteCookie('token-share');
            navigate(PATH.LOGIN);
            return;
        }

        const res = await getMerchantProfile();
        if (res?.data?.code === ERROR_CODE["AUTH-021"] || res?.code === ERROR_CODE["AUTH-005"]) {
            const refreshRes = await refresh();
            if (refreshRes?.success) {
                window.localStorage.setItem(LOCAL_STORAGE_KEY.TOKEN, refreshRes?.data?.accessToken || '');
                window.localStorage.setItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN, refreshRes?.data?.refreshToken || '');
                await handleMerchant();
            } else {
                deleteCookie('token-share');
                handleNavigation({navigate, merchantProfile: res, pathname});
            }
        } else {
            handleNavigation({navigate, merchantProfile: res, pathname});
        }
    }


    return (
        <header className="w-full min-w-0 bg-white shadow-md sticky top-0 z-50">
            <DownloadApp />
            <TopHeading />
            <Heading />
            <PopupComponent />
            <MobileModal />
        </header>
    );
};

export default Header;
